import simplify from 'simplify-js'

export const simplifyPointsBasedOnZoom = (points, zoom) => {
  // Base tolerance value that works well at different zoom levels
  // Lower values = more detail, higher values = more simplification
  const baseToleranceValue = 0.005

  // Scale factor based on zoom level
  // As zoom increases (closer view), we want less simplification
  // As zoom decreases (farther view), we want more simplification
  const zoomScaleFactor = Math.pow(0.5, (zoom - 10) / 5)

  // Calculate final tolerance
  const tolerance = baseToleranceValue * zoomScaleFactor

  try {
    // Convert points to the format expected by simplify.js ({x: lat, y: lng}[])
    const formattedPoints = points.map((point) => {
      return { x: point.lat, y: point.lng }
    })

    // Simplify the line
    const simplifiedLine = simplify(formattedPoints, tolerance, true)

    // Convert back to {lat, lng} format and return
    return simplifiedLine.map((point) => ({
      lat: point.x,
      lng: point.y,
    }))
  } catch (error) {
    console.error('Error simplifying points:', error)
    // Return original points if simplification fails
    return points
  }
}
